import { useWhoAmI } from '@/api/common/auth';
import { isEmbeddedInFrame } from '@/utils/isEmbeddedInFrame';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Production-caution cue for users whose role carries the production-caution capability on a tenant that
 * enabled it. The server resolves both conditions into `SiteInformation.ProductionCaution`.
 *
 * The legacy shell embeds this app (and this app embeds legacy pages) in iframes; only the top window
 * draws the overlay, otherwise it would render twice.
 *
 * The frame is purely visual (`pointer-events-none`); the strip takes real layout space at the bottom of
 * the shell, so it never covers page content.
 */
export function ProductionCautionOverlay() {
  const { t } = useTranslation();
  const { data } = useWhoAmI();

  if (!data?.SiteInformation?.ProductionCaution || isEmbeddedInFrame()) return null;

  return (
    <>
      <div
        aria-hidden="true"
        data-testid="layout-production-caution-frame"
        className="border-error-solid pointer-events-none fixed inset-0 z-40 border-4"
      />
      <div
        role="status"
        data-testid="layout-production-caution-strip"
        className="border-error-solid bg-error-surface text-error-text flex shrink-0 items-center justify-center gap-2 border-t px-4 pt-1 pb-2 text-xs font-bold"
      >
        <AlertTriangle className="size-3.5" aria-hidden="true" />
        {t('productionCaution.message')}
      </div>
    </>
  );
}
